import { render, staticRenderFns } from "./bizCardAddPage.vue?vue&type=template&id=1881e271&scoped=true&"
import script from "./bizCardAddPage.vue?vue&type=script&lang=js&"
export * from "./bizCardAddPage.vue?vue&type=script&lang=js&"
import style0 from "./bizCardAddPage.vue?vue&type=style&index=0&id=1881e271&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1881e271",
  null
  
)

export default component.exports